/*global ViewController, WebView, moment*/

var notificationController = new ViewController(
    {
        directory: "views/notification",
        name: "notificationPopup",
        route: "notifications",
        openInPopup: true,
        noTitle: true,
        popup: {
            size: "medium"
        },
    }
);


notificationController.prepareDataOnEnter = function(data, callback) {
    var hasNewItem = false;
    this.api.db.multiread({
        iz_notification: {
            search: {
                real_user_id: this.api.currentUser.id,
                state: ["new", "view", "sent"],
                date: {ope:"between", value: [moment().subtract(1, "month").toDate(), new Date()]}
            },
            orderBy: "date desc"
        }
    }, function(err, reads){
        if(err){ return callback(err) ;}
        reads.iz_notification.forEach(function(notif){
            notif.typeLabel = WebView.tr("notification."+notif.type);
            notif.label = WebView.tr(notif.label);
            if("notification."+notif.type === notif.typeLabel){
                notif.typeLabel = notif.label ;
            }
            if (notif.state == "new" || notif.state == "sent") {
                hasNewItem = true;
            } 
        }) ;
        callback(null, {
            notifs: reads.iz_notification,
            hasNewItem: hasNewItem
        }) ;
    }) ;
} ;

notificationController.onLink = function(ev){
    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            { 
                table: "iz_notification",
                action: "update",
                record: {
                    id: ev.data.data.id,
                    state: "view"
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            window.location.href = ev.data.data.link ;
            done();
        }) ;
    }.bind(this)) ;
} ;


notificationController.onMarkAll = function() {
    this.view.longTask(function(done){
        var records = [] ;
        this.data.notifs.forEach(function(notif){
            if (notif.state == "new" || notif.state == "sent") {
                records.push({
                    table: "iz_notification",
                    action: "update",
                    record : { id: notif.id, state: "view"}
                }) ;
            }
        }) ;
        this.api.db.transactionalChanges(records, function(err){
            if(err){ return done(err); }
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = notificationController ;